import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  ReferenceField,
  NumberField,
} from 'react-admin';

export const AttributeShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="slug" />
      <TextField source="description" />
      
      <ReferenceField source="groupId" reference="attribute-groups" link="show">
        <TextField source="name" />
      </ReferenceField>
      
      <NumberField source="sortOrder" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
